

/**
 * Return event timestamp
 *
 * @param event
 * @returns {string}
 */
export const getEventTimestamp = event => `${moment.utc(event.start_date).local().format('x')}-${event.id}`
